import barba from "controllers/barba";
import cart from "controllers/cart";
import cookies from "controllers/cookies";

import "components/logobar";
import "logobar-sketches/example";
// import 'logobar-sketches/morph'

import "views/default";
import defaultTransition from "views/transitions/default";
import deployLogo from "views/transitions/deploy-logo";

barba({
  wrapperId: "jsBarbaWrapper",
  containerClass: "js-barba-container",

  linkClicked: () => document.body.classList.add("is-loading"),
  newPageReady: () => {},
  transitionCompleted: () => document.body.classList.remove("is-loading"),

  transitionsMap: {
    fallback: defaultTransition,
    default: { home: deployLogo },
    search: { home: deployLogo },
    "list.pages": { home: deployLogo },
    "preview.shops": { home: deployLogo },
  },
});

import logobar from "components/logobar";
window.addEventListener("load", () => {
  logobar
    .open({ justForTheTransition: false, transitionDuration: 0 })
    .then(() => {
      document.getElementsByTagName("html")[0].classList.remove("js-hide_body");
      window.setTimeout(logobar.close, 1000);
    });

  cart();
  cookies();
});

document.addEventListener(
  "click",
  function (event) {
    if (!event.target.classList.contains("button--repli")) return;
    event.preventDefault();
    event.target.classList.toggle("is--active");
    event.target.nextSibling.classList.toggle("is--invisible");
  },
  false
);
